<script>
import modal from "@/components/modal";
import store from "../store/index.js";
import Spend from "./successComponent/spend";
import { isAutohomeApp } from '@/common/util';
export default {
  data() {
    return {
      params: {
        title: "询价成功",
      },
      isClickCoupon: false,
      isClose: false,
      num: 1, //显示那个成功弹框
    };
  },
  methods: {
    format(_price, decimals = 0) {
      if (!_price) {
        return "**";
      }
      let price = _price / 10000 + "";
      if (decimals > 0) {
        const arr = price.split(".");
        const length = arr[1] ? arr[1].length : 0;
        let complement = decimals - length;
        while (complement) {
          if (complement < 0) {
            arr[1] = arr[1].replace(arr[1].charAt(arr[1].length - 1), "");
            complement++;
            continue;
          } else {
            if (!arr[1]) {
              arr[1] = "0";
            } else {
              arr[1] += "0";
            }
          }
          complement--;
        }
        price = arr.join(".");
      }
      return price;
    },
    show(res) {
      res ? (this.num = res) : (this.num = 1);
      this.$refs.modal.show();
    },
    click() {
      this.$refs.modal.hide();
      // 重置用户信息
      store.form.mobile = "";
      store.form.name = "";
      if (this.isClose) {
        return;
      }
      store.isShowSuccessCoupon = false;
      this.isClose = true;
      this.$clickMonitor.send({
        buttonId: "success-close",
        ...store.getClickMonitorParams(),
      });
      console.log("mobile:", store.form.mobile);
    },
    useCoupon() {
      let link = '';
      if (isAutohomeApp()) {
        link = `autohome://carhailing/home?type=hongqi_enquiry_success_button&couponId=${store.couponId}`;
      } else {
        link = `https://etravel-h5.autohome.com.cn/#/?pvareaid=6844832&couponId=${store.couponId}`;
      }
      if (this.isClickCoupon) {
        window.open(link);
        return;
      }
      this.isClickCoupon = true;
      this.$clickMonitor.send({
        buttonId: "success-coupon-click",
        ...store.getClickMonitorParams(),
      });
      window.open(link);
    },
  },
  computed: {
    lowerPrice() {
      return store.price.lower.lastMonthDealPrice;
    },
    normalPrice() {
      return store.price.normal.price;
    },
    isShowSuccessCoupon() {
      return store.isShowSuccessCoupon;
    },
    seriesName() {
      return store.form.series.name;
    },
    recommendSeriesFixedItems() {
      return store.recommendSeriesFixedItems;
    },
    couponValue() {
        return store.couponValue;
    },
    returnBlockArr() {
      return store.returnBlockArr;
    },
    returnBlockLowerPrice() {
      return store.returnBlockMainPrice.lower.lastMonthDealPrice;
    },
    returnBlockNormalPrice() {
      return store.returnBlockMainPrice.normal.price;
    },
    returnMainSeriesName() {
      return store.returnMainSeriesName;
    }
  },

  components: {
    modal,
    Spend,
  },
};
</script>

<template>
  <modal ref="modal">
    <div v-if="num == 1" class="success-container">
      <div class="success-inner">
        <div class="header">
          <div class="header-title">
            <img src="../../assets/success.png" alt="" />
            <h4>询价成功</h4>
          </div>
          <div class="tips">我们将及时为您报价</div>
        </div>
        <div class="content" v-if="lowerPrice">
          <span>最新成交参考价</span>
          <h3>{{ this.format(lowerPrice, 2) + "万元" }}</h3>
        </div>
        <div class="content" v-if="!lowerPrice && normalPrice">
          <span>厂商指导价</span>
          <h3>{{ this.format(normalPrice, 2) + "万元" }}</h3>
        </div>
        <div class="content" v-if="!lowerPrice && !normalPrice">
          <span>最新成交参考价</span>
          <h3>暂无价格</h3>
        </div>
        <div class="go-out-block" v-show="isShowSuccessCoupon">
          <div class="go-out-title">之家出行送您去看车</div>
          <div class="go-out-img-wrap" @click="useCoupon()">
            <img
              src="../../assets/success-coupon.png"
              alt=""
              class="go-out-img"
            />
            <div class="go-out-text">打车到店立减{{couponValue}}元</div>
          </div>
          <div class="go-out-des">
            {{couponValue}}元券发放位置：首页-右下角“我”-“我的优惠券”，点击“去使用”即可下单
          </div>
        </div>
        <div class="button" @click="click">继续咨询</div>
      </div>
    </div>

    <div v-if="num == 2" class="success-container1">
      <!-- 带推荐、去重的成功弹窗 -->
      <div class="success-inner">
        <div class="header">
          <div class="header-title">
            <img src="../../assets/success.png" alt="" />
            <h4>询价成功</h4>
          </div>
          <div class="tips">我们将及时为您报价</div>
        </div>
        <div class="content">
          <span>最新成交参考价</span>
          <h3>
            <span>{{ seriesName }}:</span
            ><span class="price" style="margin-left:6px">
              {{
                lowerPrice
                  ? this.format(lowerPrice, 2) + "万元"
                  : !lowerPrice && normalPrice
                  ? this.format(normalPrice, 2) + "万元"
                  : !lowerPrice && !normalPrice
                  ? "暂无价格"
                  : ""
              }}
            </span>
          </h3>
          <div :key="index"  v-for="(item, index) in recommendSeriesFixedItems">
              <h3 v-if="item.checked==true || item.recoChecked == true" >
                <span>{{ item.seriesName }}:</span>
                <span class="price">
                {{
                    item.price && item.price[1].lastMonthDealPrice
                    ? format(item.price[1].lastMonthDealPrice, 2) + "万元"
                    : item.price && item.price[0].price
                    ? format(item.price[0].price, 2) + "万元"
                    : "暂无价格"
                }}
                </span>
            </h3>
          </div>
        </div>
        <!-- <Spend></Spend> -->

        <div class="go-out-block" v-show="isShowSuccessCoupon">
        <!-- <div class="go-out-block"> -->
          <div class="go-out-title">之家出行送您去看车</div>
          <div class="go-out-img-wrap" @click="useCoupon()">
            <img
              src="../../assets/success-coupon.png"
              alt=""
              class="go-out-img"
            />
            <div class="go-out-text">打车到店立减{{couponValue}}元</div>
          </div>
          <div class="go-out-des">
            {{couponValue}}元券发放位置：首页-右下角“我”-“我的优惠券”，点击“去使用”即可下单
          </div>
        </div>
        <div class="buttonsubmit" @click="click">继续咨询</div>
      </div>
    </div>

    <div v-if="num == 3" class="success-container1">
      <!-- 默认推荐弹框 success -->
      <div class="success-inner">
        <div class="header">
          <div class="header-title">
            <img src="../../assets/success.png" alt="" />
            <h4>询价成功</h4>
          </div>
          <div class="tips">我们将及时为您报价</div>
        </div>
        <div class="content">
          <span>最新成交参考价</span>
          <h3>
            <span>{{ seriesName }}:</span
            ><span class="price" style="margin-left:6px">
              {{
                lowerPrice
                  ? this.format(lowerPrice, 2) + "万元"
                  : !lowerPrice && normalPrice
                  ? this.format(normalPrice, 2) + "万元"
                  : !lowerPrice && !normalPrice
                  ? "暂无价格"
                  : ""
              }}
            </span>
          </h3>
          <div :key="index"  v-for="(item, index) in recommendSeriesFixedItems">
              <h3 v-if="item.checked==true" >
                <span>{{ item.seriesName }}:</span>
                <span class="price">
                {{
                    item.price && item.price[1].lastMonthDealPrice
                    ? format(item.price[1].lastMonthDealPrice, 2) + "万元"
                    : item.price && item.price[0].price
                    ? format(item.price[0].price, 2) + "万元"
                    : "暂无价格"
                }}
                </span>
            </h3>
          </div>
        </div>
        <!-- <Spend></Spend> -->

        <div class="go-out-block" v-show="isShowSuccessCoupon">
        <!-- <div class="go-out-block"> -->
          <div class="go-out-title">之家出行送您去看车</div>
          <div class="go-out-img-wrap" @click="useCoupon()">
            <img
              src="../../assets/success-coupon.png"
              alt=""
              class="go-out-img"
            />
            <div class="go-out-text">打车到店立减{{couponValue}}元</div>
          </div>
          <div class="go-out-des">
            {{couponValue}}元券发放位置：首页-右下角“我”-“我的优惠券”，点击“去使用”即可下单
          </div>
        </div>
        <div class="buttonsubmit" @click="click">继续咨询</div>
      </div>
    </div>

    <div v-if="num == 4" class="success-container1">
      <!-- 退出页面的挽留模块提交线索后的成功弹窗 -->
      <div class="success-inner">
        <div class="header">
          <div class="header-title">
            <img src="../../assets/success.png" alt="" />
            <h4>询价成功</h4>
          </div>
          <div class="tips">我们将及时为您报价</div>
        </div>
        <div class="content">
          <span>最新成交参考价</span>
          <h3>
            <span>{{returnMainSeriesName}}</span
            ><span class="price" style="margin-left:6px">
              {{
                returnBlockLowerPrice
                  ? this.format(returnBlockLowerPrice, 2) + "万元"
                  : !returnBlockLowerPrice && returnBlockNormalPrice
                  ? this.format(returnBlockNormalPrice, 2) + "万元"
                  : !returnBlockLowerPrice && !returnBlockNormalPrice
                  ? "暂无价格"
                  : ""
              }}
            </span>
          </h3>
          <div :key="index"  v-for="(item, index) in returnBlockArr">
              <h3 v-if="item.checked==true">
                <span>{{ item.seriesName }}:</span>
                <span class="price">
                {{
                    item.price && item.price[1].lastMonthDealPrice
                    ? format(item.price[1].lastMonthDealPrice, 2) + "万元"
                    : item.price && item.price[0].price
                    ? format(item.price[0].price, 2) + "万元"
                    : "暂无价格"
                }}
                </span>
            </h3>
          </div>
        </div>
        <!-- <Spend></Spend> -->
        <div class="buttonsubmit" @click="click">继续咨询</div>
      </div>
    </div>
  </modal>
</template>

<style lang="stylus" scoped>
.success-container
    display flex
    justify-content center
    align-items center
    width 100%
    height 100%
    .success-inner
        width 16rem
        border-radius 0.746rem
        background-color #fff
    .header
        margin 0 0.53rem
        padding 1.6rem 0 1.06rem
        text-align center
        border-bottom 0.053rem solid #ebebeb
        &-title
            position relative
            display inline-block
            padding-left 1.6rem
        &-title img
            position absolute
            top 0
            left 0
            bottom 0
            margin auto
            width 1.173rem
            height 1.173rem
        &-title h4
            display inline-block
            line-height 1.4
            font-size 1.06rem
            font-weight 600
            text-align center
            color #111e36
        .tips
            margin-top 0.53rem;
            line-height 1.2
            font-size 0.9rem
            color #111e36
    .content
        padding 1.06rem 0 1rem
        text-align center
        span
            font-size 0.64rem
            color #666d7f
        h3
            margin-top 0.32rem
            font-size 1.55rem
            line-height 1.2
            font-weight bold
            color #ff6600
    .go-out-block

        .go-out-title
            color #0055FF;
            font-size:1.07rem;
            text-align center;
        .go-out-img-wrap
            position relative;
            .go-out-text
                position absolute;
                top 2.4rem;
                left 3.7rem;
                z-index 5;
                color #7F0100;
                font-size .6rem;
                line-height .9rem;
            .go-out-img
                width 14.73rem;
                display block;
                margin 1rem auto;
        .go-out-des
            font-size:0.53rem;
            color #999999;
            box-sizing border-box;
            padding 0 1rem 1rem;
    .button
        margin 0 auto 1.38rem
        width 12.53rem
        height 2.346rem
        line-height 2.346rem
        text-align center
        font-size 0.853rem
        border-radius 1.173rem
        background linear-gradient(135deg,rgba(255,168,0,1) 0%,rgba(255,60,0,1) 100%)
        color #fff

/** 推荐车系样式 */
.success-container1
    display flex
    justify-content center
    align-items center
    width 100%
    height 100%
    .success-inner
        width 17rem
        max-height 80%
        overflow-y scroll
        border-radius 0.746rem
        background-color #fff
    .header
        margin 0 0.53rem
        padding 1.6rem 0 1.06rem
        text-align center
        border-bottom 0.053rem solid #ebebeb
        &-title
            position relative
            display inline-block
            padding-left 1.6rem
        &-title img
            position absolute
            top 0
            left 0
            bottom 0
            margin auto
            width 1.173rem
            height 1.173rem
        &-title h4
            display inline-block
            line-height 1.4
            font-size 1.06rem
            font-weight 600
            text-align center
            color #111e36
        .tips
            margin-top 0.53rem;
            line-height 1.2
            font-size 0.9rem
            color #111e36
    .content
        padding 1.06rem 0 1rem
        text-align center
        span
            font-size 0.64rem
            color #666d7f
        h3
            margin-top 0.32rem
            font-size 1.55rem
            line-height 1.2
            font-weight bold
            color #ff6600
            span 
                width 40%
                display inline-block
                text-align right 
            .price
                width 50%
                color: #f60;
                font-size: 20px;
                text-align left ;
    .go-out-block

        .go-out-title
            color #0055FF;
            font-size:1.07rem;
            text-align center;
        .go-out-img-wrap
            position relative;
            .go-out-text
                position absolute;
                top 2.4rem;
                left 3.7rem;
                z-index 5;
                color #7F0100;
                font-size .6rem;
                line-height .9rem;
            .go-out-img
                width 14.73rem;
                display block;
                margin 1rem auto;
        .go-out-des
            font-size:0.53rem;
            color #999999;
            box-sizing border-box;
            padding 0 1rem 1rem;
    .buttonsubmit
        margin 0 auto 1.38rem
        width 12.53rem
        height 2.346rem
        line-height 2.346rem
        text-align center
        font-size 0.853rem
        border-radius 1.173rem
        background linear-gradient(135deg,rgba(255,168,0,1) 0%,rgba(255,60,0,1) 100%)
        color #fff
</style>
